import React from "react";

const LeftArrowIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
       <path d="M23.244 25.428A2.741 2.741 0 0024 27.322c0 .732-.286 1.398-.753 1.891l.001-.001a2.503 2.503 0 01-3.64.008L8.752 17.896c-.466-.493-.752-1.16-.752-1.894s.286-1.401.754-1.895l-.001.001L19.356 2.679a2.513 2.513 0 011.812-.783h.001a2.512 2.512 0 011.811.783l.001.001c.466.493.752 1.16.752 1.894s-.286 1.401-.754 1.895l.001-.001-9.039 9.428z" />
  </svg>
);

export default LeftArrowIcon;